import CSS from './x-store-reviews-teaser.pcss';

export class XStoreReviewsTeaser extends HTMLElement {
	static componentName: string = 'x-store-reviews-teaser';

	protected _count: number;
	protected _average: number;
	protected _booted: boolean = false;

	constructor() {
		super();
	}

	private _buildDom() {
		const shadow = this.attachShadow({ mode: 'open' });

		shadow.innerHTML = `
			<div id="tt-teaser-icons" style="display:none;">
				<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
				<symbol id="tt-teaser-star--empty" viewBox="0 0 24 24">
				<path d="M12 18l-6.4 3.88 1.73-7.33-5.66-4.93L9.09 9 12 2.09 14.91 9l7.42.64-5.63 5 1.72 7.34z" fill="none" xmlns="http://www.w3.org/2000/svg"></path>
				</symbol>
				
				<symbol id="tt-teaser-star--full" viewBox="0 0 24 24">
				<path d="M12 18.66l-7.44 4.35 1.98-8.16L0 9.36l8.62-.7L12 .99l3.38 7.67 8.62.7-6.54 5.49 1.98 8.16L12 18.66z" xmlns="http://www.w3.org/2000/svg"></path>
				</symbol>
				
				<symbol id="tt-teaser-star--half" viewBox="0 0 24 24">
				<path fill="currentColor" d="M12 2.09L9.09 9l-7.42.62 5.66 4.93-1.72 7.32 1.07-.65L12 17.97V2.09z" xmlns="http://www.w3.org/2000/svg"></path>
				<path d="M12 2.09L14.91 9l7.42.62-5.66 4.93 1.72 7.32-1.07-.65L12 17.97V2.09z"></path>
				</symbol>
			</svg>
			</div>
			<style>${CSS}</style>
			<div class="x-store-reviews-teaser">
				<div class="x-store-reviews-teaser__avg">Average Rating: 
					<span id="average"></span>
					<div id="stars" aria-hidden="true"></div>
				</div>
				<div class="x-store-reviews-teaser__total">Total Number of Reviews: <span id="count"></span></div>
			</div>`;

		//mark the component as ready
		this._booted = true;

		return this;
	}

	/**
	 * Generate an individual store element
	 * @param starType
	 * @protected
	 */
	protected generateStar(starType) {
		let svgEl = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		svgEl.setAttribute('class', 'teaser-icon--' + starType);
		let useEl = document.createElementNS('http://www.w3.org/2000/svg', 'use');
		useEl.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#tt-teaser-star--' + starType);
		svgEl.appendChild(useEl);
		let el = document.createElement('span');
		el.appendChild(svgEl);
		return el;
	}

	protected generateStars(rating) {
		let container = document.createElement('div');

		for (let i = 1; i <= 5; i++) {
			if (rating >= i) {
				let starEl = this.generateStar('full');
				container.appendChild(starEl);
			} else if (rating === i) {
				let starEl = this.generateStar('full');
				container.appendChild(starEl);
			} else if (rating < i && rating > i - 1) {
				let starEl = this.generateStar('half');
				container.appendChild(starEl);
			} else {
				let starEl = this.generateStar('empty');
				container.appendChild(starEl);
			}
		}

		return container;
	}

	/**
	 * Set the InnerHTML on a given ID element
	 * @param id
	 * @param value
	 * @protected
	 */
	protected setDOM(id, value) {
		try {
			this.shadowRoot.getElementById(id).innerHTML = value;
		} catch (e) {
			//can not set element
		}
	}

	protected appendToDOM(id, value) {
		let el = this.shadowRoot.getElementById(id);
		if (el.firstChild) {
			el.firstChild.remove();
		}

		el.appendChild(value);
	}

	async connectedCallback() {
		if (!this._booted) {
			this._buildDom();
		}

		let average = parseFloat(this.getAttribute('average')).toFixed(1);

		this.setDOM('count', parseFloat(this.getAttribute('count')));
		this.setDOM('average', average);

		let stars = this.generateStars(average);

		this.appendToDOM('stars', stars);
	}

	static get observedAttributes() {
		return ['count', 'average'];
	}

	attributeChangedCallback(name, oldValue, newValue) {
		if (!this._booted) {
			this._buildDom();
		}

		if (name === 'count') {
			this.setDOM('count', newValue);
		} else if (name === 'average') {
			let average = parseFloat(newValue).toFixed(1);
			this.setDOM('average', average);

			let stars = this.generateStars(average);

			this.appendToDOM('stars', stars);
		}
	}
}

if (!customElements.get(XStoreReviewsTeaser.componentName)) {
	customElements.define(XStoreReviewsTeaser.componentName, XStoreReviewsTeaser);
}
